<template>
  <v-img v-bind="$attrs" :src="src" alt="logo"></v-img>
</template>

<script>
/**
 * @displayName Logo
 */
export default {
  name: 'ZLogo',
  props: {
    type: {
      type: String,
      required: false,
      default: '',
    },
    aspectRatio: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    height: {
      type: [Number, String],
      required: false,
      default: undefined,
    },
    minHeight: {
      type: [Number, String],
      required: false,
      default: undefined,
    },
    maxHeight: {
      type: [Number, String],
      required: false,
      default: undefined,
    },
    width: {
      type: [Number, String],
      required: false,
      default: undefined,
    },
    minWidth: {
      type: [Number, String],
      required: false,
      default: undefined,
    },
    maxWidth: {
      type: [Number, String],
      required: false,
      default: undefined,
    },
  },
  computed: {
    src() {
      switch (this.type) {
        case 'blue':
          return require('../../../assets/img/logo-blue.png')

        case 'simple':
          return require('../../../assets/img/logo-simple.png')

        case 'z':
          return require('../../../assets/img/logo-z.png')

        default:
          return require('../../../assets/img/logo.png')
      }
    },
  },
}
</script>
